var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranscriptBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_128_26",
    "data-name": "Group 128 26",
    transform: "translate(-288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_490",
    "data-name": "Ellipse 490",
    transform: "translate(288)",
    fill: "#08f",
    stroke: "#08f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "transcript",
    transform: "translate(291 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12811",
    "data-name": "Group 12811",
    transform: "translate(2 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12708",
    "data-name": "Path 12708",
    d: "M10,30.778A.8.8,0,0,1,10.818,30h6.545a.779.779,0,1,1,0,1.556H10.818A.8.8,0,0,1,10,30.778Z",
    transform: "translate(-6.727 -20.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12709",
    "data-name": "Path 12709",
    d: "M25.364,22a.779.779,0,1,1,0,1.556H18.818a.779.779,0,1,1,0-1.556Z",
    transform: "translate(-11.455 -15.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12710",
    "data-name": "Path 12710",
    d: "M32,30.778A.8.8,0,0,1,32.818,30h.818a.779.779,0,1,1,0,1.556h-.818A.8.8,0,0,1,32,30.778Z",
    transform: "translate(-19.727 -20.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12711",
    "data-name": "Path 12711",
    d: "M11.636,22a.779.779,0,1,1,0,1.556h-.818a.779.779,0,1,1,0-1.556Z",
    transform: "translate(-6.727 -15.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2050",
    "data-name": "Rectangle 2050",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 13,
    rx: 1.5,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscriptBlue);
export default __webpack_public_path__ + "static/media/TranscriptBlue.92a1ba4a47f4f515a5d5bd1224c7284d.svg";
export { ForwardRef as ReactComponent };